import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取最近修改的对单记录
export function queryDocHistoryByTime(params) {
  return request({
    url: URL.seaExport.queryDocHistoryByTime,
    method: 'get',
    params
  })
}

// 获取最近修改的对单记录
export function queryDocHistoryJsonFunc(params) {
  return request({
    url: URL.seaExport.queryDocHistoryJsonUrl,
    method: 'get',
    params
  })
}

// 根据cargoDocUuid获取改cargoDoc的对单修改记录
export function queryDocHistory(params) {
  return request({
    url: URL.seaExport.queryDocHistory,
    method: 'get',
    params
  })
}

// 根据jobUUID获取改SeaExportJob的记录
export function queryReceiptHistory(params) {
  return request({
    url: URL.seaExport.queryReceiptHistory,
    method: 'get',
    params
  })
}
